export default __webpack_public_path__ + "static/desk12-b00caba8147eaa2922097a08b63f467f.png";